// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.src-pages-management-DocPage-DocPage-module__docPage--OedAx {
  padding: 16px;
}
.src-pages-management-DocPage-DocPage-module__docPage--OedAx td {
  border: silver solid thin;
  padding: 8px;
}
.src-pages-management-DocPage-DocPage-module__docPage--OedAx li {
  margin-left: 24px;
}
/*# sourceMappingURL=DocPage.module.css.map */`, "",{"version":3,"sources":["webpack://./DocPage.module.less","webpack://./src/pages/management/DocPage/DocPage.module.less"],"names":[],"mappings":"AAAA;EACE,aAAA;ACCF;ADFA;EAGI,yBAAA;EACA,YAAA;ACEJ;ADNA;EAOI,iBAAA;ACEJ;AACA,6CAA6C","sourcesContent":[".docPage {\n  padding: 16px;\n  td {\n    border: silver solid thin;\n    padding: 8px;\n  }\n  li {\n    margin-left: 24px;\n  }\n}\n",".docPage {\n  padding: 16px;\n}\n.docPage td {\n  border: silver solid thin;\n  padding: 8px;\n}\n.docPage li {\n  margin-left: 24px;\n}\n/*# sourceMappingURL=DocPage.module.css.map */"],"sourceRoot":""}]);
// Exports
export var docPage = `src-pages-management-DocPage-DocPage-module__docPage--OedAx`;
export default ___CSS_LOADER_EXPORT___;
